// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG button","primary":"Button_primary__VIPCG","danger":"Button_danger__fX46X","warning":"Button_warning__nheYI","flat":"Button_flat__iI2ki"};